import { DashboardTab } from '../services/tenant-config-service';

export const DEFAULT_DASHBOARD_TABS: Omit<DashboardTab, 'id'>[] = [
  {
    tag: 'Counselor',
    label: 'Inner Mastery Guide',
    priority: 1,
    is_active: true,
  },
  {
    tag: 'Action',
    label: 'Leadership Gym',
    priority: 2,
    is_active: true,
  },
  {
    tag: 'Coach',
    label: 'Performance Coach',
    priority: 3,
    is_active: true,
  },
];
